export const COOKIE = {
  PAGE_RELOADED: 'p_r'
}
